module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/overview"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tachometer"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Overview")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/users"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("User List")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/videos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-film"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Videos")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/documents"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Documents")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/categories"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Categories")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/industries"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-industry"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Industry")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/products"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Products")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/organisations"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Organisations")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/product-request"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Product Requests")])])]), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/product-catalog-product"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Product per Product Catalog")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/product-catalog-category"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Category per Product Catalog")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/product-type"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Product Type")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/distributors"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Distributors")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/admin/product-colours"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Product Colours")])])])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "clor-w",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" "), _c('span', {
    staticClass: "treeview-title"
  }, [_vm._v("Product Catalog")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container pull-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-fw"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65ca5e0b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SidebarMenu.vue
// module id = 2102
// module chunks = 1